import React from 'react';

// Utils //
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

// Styles //
import "./cardStepTalent.scss";
import "../number-steps/numberSteps.scss"

interface DocumentCardProps {
    title: string;
    description: any;
    image: string;
    button?: string;
    modalInfo?: any;
    setModalInfo?: any;
    setIsOpenModal?: any;
}

const CardStepTalent = (props: DocumentCardProps) => {
    const {title, description, image, button, modalInfo, setIsOpenModal, setModalInfo} = props;
    return (
        <div className={`m-card-step-talent ${title}`}>
            <div className="m-card-step-talent__image">
                <img src={image} alt={title} />
            </div>
            <div className="m-card-step-talent__description">
                <h3>{title}</h3>
                {contentfulRenderOptions(description.json)}
                {button && 
                    <button 
                        onClick={()=>{
                            setIsOpenModal(true);
                            setModalInfo(modalInfo);
                        }} 
                        className={`m-card-step-talent__action card-button-${title}`}>
                            {button}
                    </button>
                }
            </div>
        </div>
    )
}

export default CardStepTalent